




































































import { FormModal } from '@/app/components';
import { computed, defineComponent } from '@vue/composition-api';
import { AssetType } from '../constants/asset-type.constants';
import { StatusCode } from '../constants/status-codes.constants';

export default defineComponent({
    name: 'DependingAssetsModal',
    components: {
        FormModal,
    },
    props: {
        pendingInputs: {
            type: Object,
            required: true,
        },
        assetType: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const pendingModels = computed(() => [
            ...props.pendingInputs.models,
            ...props.pendingInputs.assets.filter((pendingInput: any) => pendingInput.type === AssetType.Model),
        ]);

        const pendingResults = computed(() =>
            props.pendingInputs.assets.filter((pendingInput: any) => pendingInput.type === AssetType.Result),
        );
        const pendingDatasets = computed(() =>
            props.pendingInputs.assets.filter((pendingInput: any) => pendingInput.type === AssetType.Dataset),
        );

        return {
            AssetType,
            pendingModels,
            pendingResults,
            pendingDatasets,
            StatusCode,
        };
    },
});
